import './passcode.css';

import { EventEmitter } from "eventemitter3";
import { Context } from "../../../models/context";
import { DataLayerService } from '../../../services/data-layer-service';
import { LocalizationService } from '../../../services/localization-service';
import { Modal } from '../modal';
import { Util } from "../../../utils/util";


export class Passcode extends Modal {
    private readonly callbackResendCode: () => Promise<void>;
    private readonly callbackSignIn: (value: string) => Promise<boolean>;

    constructor(
        eventBus: EventEmitter,
        context: Context,
        localizationService: LocalizationService,
        dataLayer: DataLayerService,
        callbackResendCode: () => Promise<void>,
        callbackSignIn: (value: string) => Promise<boolean>
    ) {
        super("modal_passcode", eventBus, context, dataLayer, localizationService, { hasCloseButton: true, ariaLabel: "Passcode" });

        this.callbackResendCode = callbackResendCode;
        this.callbackSignIn = callbackSignIn;
    }

    protected _setEventListeners(): void {
        const buttonResend = document.getElementById("btn_passcode_resend");
        buttonResend?.addEventListener("click", this._onResendClick);

        const buttonSignin = document.getElementById("btn_passcode_signin");
        buttonSignin?.addEventListener("click", this._signin);
    }

    private readonly _onResendClick = async (): Promise<void> => {
        await this.callbackResendCode();
    };

    private readonly _signin = async (): Promise<void> => {
        const input = document.getElementById("passcode_inputbox") as HTMLInputElement;
        const code = input.value ?? "";

        let loginSuccess = await this.callbackSignIn(code);

        if (loginSuccess)
            this.close();
        else
            this._showErrorElement();
    };

    override init(): void {
        super.init();
        this._setEventListeners();
    }

    override open(): void {
        super.open();
        this._hideErrorElement();
        Util.ensureAnnouncerPresent();
    }

    private _hideErrorElement(): void {
        Util.hideElement("spn_passcode_error");
    }

    private _showErrorElement(): void {
        Util.showElement("spn_passcode_error");
    }
}